module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="headline" class="bill-list-headline"></div>\n<div id="bill-list"></div>';
}
return __p;
};
